<template>
  <div class="login-form">
    <div class="form border ">
      <router-link class="back-btn" :to="{ name: 'login' }">{{
        $lang("TEXT_LOGIN")
      }}</router-link>
      <b-form @submit="onSubmit">
        <div>
          <b-form-group class="phone">
            <template slot="label">
              <label></label>
            </template>
            <b-form-input
              v-model="form.mobile"
              type="text"
              key="mobile"
              name="mobile"
              :class="errors.has('mobile') && 'is-invalid'"
              :placeholder="$lang('FIELD_PHONE')"
              v-validate="{ required: true, mobile: true }"
            ></b-form-input>
            <b-form-invalid-feedback :state="errors.has('mobile')">
              {{ errors.first("mobile") }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <DatePicker
              type="date"
              v-model="form.bornAt"
              :placeholder="$lang('出生日期：')"
              name="bornAt"
              size="large"
              :class="errors.has('bornAt') && 'is-invalid'"
              v-validate="{ required: true }"
              format="yyyy/MM/dd"
            ></DatePicker>
            <b-form-invalid-feedback :state="errors.has('bornAt')">
              {{ errors.first("bornAt") }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group class="verification authentication">
            <template slot="label">
              <label></label>
            </template>
            <b-form-input
              v-model="form.captcha"
              type="text"
              key="code"
              :state="codeState"
              name="verificationCode"
              :class="errors.has('verificationCode') && 'is-invalid'"
              :placeholder="$lang('FILED_CAPTCHA')"
              v-validate="{ required: true }"
            ></b-form-input>
            <b-btn variant="info" @click="getCode" :disabled="disabled">
              <span class="tip" v-if="!sendMsgDisabled && !reGet">{{
                $lang("發送驗證碼")
              }}</span>
              <span class="tip" v-if="!sendMsgDisabled && reGet">{{
                $lang("重新獲取")
              }}</span>
              <span class="tip" v-if="sendMsgDisabled">{{
                rTime + $lang("秒後重新獲取")
              }}</span>
            </b-btn>
            <b-form-invalid-feedback :state="errors.has('verificationCode')">
              {{ errors.first("verificationCode") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <b-button type="submit" class="login" variant="primary">{{
          $lang("找回賬戶")
        }}</b-button>
      </b-form>
      <h4 v-html="$lang('TEXT_IF_NOT_EMAIL_CHANGE_PWD')"></h4>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import LaddaBtn from "@/components/ladda/Ladda";
export default {
  components: {
    LaddaBtn,
  },
  data() {
    return {
      form: {
        bornAt: "",
        captcha: "",
        mobile: "",
      },
      scene: "retrieveAccount",
      loginLoading: false,
      codeState: null,
      reGet: false, // 重新获取
      rTime: 60, // 发送验证码倒计时
      sendMsgDisabled: false, // 发送验证码按钮状态
      disabled: false,
      tel: "",
      code: "",
    };
  },
  computed: {
    ...mapGetters("user", {
      captcha: "captcha",
      captcha_url: "captcha_url",
      sid: "sid",
    }),
  },
  watch: {},
  methods: {
    ...mapActions("user", ["forgetPassword"]),
    onSubmit(evt) {
      evt.preventDefault();
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          console.log(valid);
          this.loginLoading = true;
          this.$apis
            .retrieveAccount({
              ...this.form,
              scene: this.scene,
              bornAt: moment(this.form.bornAt).format("YYYY-MM-DD"),
            })
            .then((resp) => {
              this.loginLoading = false;
              if (resp.code == 0) {
                this.notification.success(this.$lang(resp.message));
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.code == 10003) {
                this.errors.add({
                  field: "verificationCode",
                  msg: this.$lang("驗證碼不正確"),
                });
              } else {
                this.notification.error(this.$lang(err.message));
              }
            });
        } else {
          return false;
        }
      });
    },
    sendCode(params) {
      return this.$apis.sendCode(params);
    },
    getCode() {
      this.$validator.validateAll(["mobile", "bornAt"]).then((valid) => {
        if (valid) {
          let that = this;
          that.sendMsgDisabled = true;
          let rTime = that.rTime;
          that.disabled = true;
          let params = {
            mobile: this.form.mobile,
            scene: this.scene,
            bornAt: moment(this.form.bornAt).format("YYYY-MM-DD"),
          };
          this.sendCode(params)
            .then((res) => {
              //倒计时
              if (res.data == 0) {
                let interval = setInterval(() => {
                  if (--that.rTime <= 0) {
                    that.rTime = rTime;
                    that.sendMsgDisabled = false;
                    that.disabled = false;
                    that.reGet = true; // 重新获取按钮
                    clearInterval(interval);
                  }
                }, 1000);
              } else {
                that.disabled = false;
                that.sendMsgDisabled = false;
              }
            })
            .catch((err) => {
              that.disabled = false;
              that.sendMsgDisabled = false;
              this.notification.error(this.$lang(err.message));
            });
        }
      });
    },
  },
};
</script>
